import React from 'react';
import './FirstScreen.scss';
import AnimatedImage from "./AnimatedImage/AnimatedImage";
import EmLogo from  "../../resources/el-logo.svg";

function FirstScreen() {
    return (
        <div className="FirstScreen modal-bg">
            <div className="content">
                <div className={'mainText'}>
                    <div id={'turn-key-services'}/>
                    <div className={'titleKey'}>From concept to production - with full responsibility</div>
                    <div className={'title'}>
                        Engineering complex <br/>
                        software systems <br/>
                        and applied AI solutions
                    </div>
                    {/*<div className={'title gradient'}>Development Company</div>*/}
                    <div className={'aboutUs'}>Tahion designs and delivers custom software platforms, operational
                        systems and digital products for organizations working under scale, uncertainty and
                        technological change.

                        <div className={'titleAboutUs gradient'}>Trusted by technology companies, operational
                            organizations and global institutions.</div>
                    </div>

                    <a href="#contact-us" className="buttonContactUs">Start Engineering Discussion</a>

                    {/*<a href="https://emotionlogic.ai/partner-with-us/" className={'em-logo'} target={'_blank'}>*/}
                    {/*    <img src={EmLogo} alt={'Emotion Login Trusted Development Partner'}/>*/}
                    {/*</a>*/}
                </div>
                <AnimatedImage/>
            </div>
        </div>
    );
}

export default FirstScreen;
